class LocalLogger {
  constructor(maxLogs = 10000) {
    this.maxLogs = maxLogs;
    this.storageKey = 'app_logs';
  }

  log(level, message, data = {}) {
    const logEntry = {
      timestamp: new Date().toISOString(),
      level: level,
      message: message,
      data: data,
    };

    let logs = this.getLogs();
    logs.push(logEntry);

    // 限制日志数量
    if (logs.length > this.maxLogs) {
      logs = logs.slice(-this.maxLogs);
    }

    localStorage.setItem(this.storageKey, JSON.stringify(logs));
    // console[level.toLowerCase()](message, data);
  }

  getLogs() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey) || '[]');
    } catch {
      return [];
    }
  }

  clearLogs() {
    localStorage.removeItem(this.storageKey);
  }

  downloadLogs() {
    const logs = this.getLogs();
    const logText = logs
      .map((log) => `[${log.timestamp}] [${log.level}] ${log.message} ${JSON.stringify(log.data)}`)
      .join('\n');

    const blob = new Blob([logText], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `logs_${new Date().toISOString().split('T')[0]}.txt`;
    a.click();
    URL.revokeObjectURL(url);
  }

  info(message, data) {
    this.log('INFO', message, data);
  }

  error(message, data) {
    this.log('ERROR', message, data);
  }
}

// 使用示例
const localLogger = new LocalLogger();
export default localLogger;
